export const TWO_FA_LAYER_EVENTS = {
  SUBMIT_TOKEN_SUCCESS: 'FETCH_LOGS_SUCCESS',
  SUBMIT_TOKEN_FAILURE: 'SUBMIT_TOKEN_FAILURE',
  RESEND_OTP_SUCCESS: 'RESEND_OTP_SUCCESS',
  RESEND_OTP_FAILURE: 'RESEND_OTP_FAILURE',
};
